// Shared row display helpers for Manager -> Team Users and Team List
// (styles in ManagerTeamUsersPage.css, scoped to .team-users-page).
import React from "react";

// Stable avatar colour per name (6 tones: .tu-avatar-0 .. .tu-avatar-5).
export const avatarTone = (name = "") => {
  let h = 0;
  for (const ch of String(name)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h % 6;
};

// "data_analyst" / "Data Analyst" -> "data-analyst" (.tu-role-<key>).
export const roleKey = (role) => String(role || "").trim().toLowerCase().replace(/[^a-z]+/g, "-");

export const Empty = () => <span className="tu-empty">—</span>;
